import './TeamsPage.scss';
import React, { useState } from "react";
import Spinner from '../../Spinner';
import teamsIcon from '../../../assets/icons/team-icon-colored.png';
import clockIcon from '../../../assets/icons/clock-icon.png';
import { UsersThree } from '@phosphor-icons/react';
import { useTeamsContext } from '../../../contexts/TeamsContext';
import Team from './Team';

export default function TeamsPage(props) {
    const {
        teams,
        getTeams
    } = useTeamsContext();

    const [mainStage, setMainStage] = useState('My Teams');
    const [subStage, setSubStage] = useState('teams');
    const [team, setTeam] = useState(null);

    const mainStageSwitch = (mainStage) => {
        switch (mainStage) {
            case 'My Teams':
                return (
                  <div className='teams-page-content-my-teams'>
                    {!teams ?
                    <Spinner />
                    :
                    teams && teams.length === 0 ?
                    <div style={{ padding: 15, borderRadius: 10, backgroundColor: 'rgba(138, 138, 138, 0.4)', width: '93%', gap: 5 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: '0.5rem'}}>
                            <img src={clockIcon} style={{ width: 20, height: 20, filter: 'invert(100%)' }}/>
                            <div style={{ fontSize: 18, color: 'black', fontWeight: 'bold' }}>Coming soon</div>
                        </div>
                        <div style={{  fontSize: 13, color: 'black' }}>Exciting updates are on the way—stay tuned for more features coming soon!</div>
                    </div>
                    :
                    <div className='teams-page-content-my-teams-table'>
                        {teams && teams.map((team) => {
                            return (
                                <div
                                    className='teams-page-content-my-teams-table-team'
                                    onClick={() => {
                                        setTeam(team);
                                        setSubStage('team');
                                    }}
                                    >
                                    <img 
                                        className='teams-page-content-my-teams-table-team-img'
                                        src={team.image_url}
                                    />
                                    <div className='teams-page-content-my-teams-table-team-name'>
                                        <UsersThree size={20} />
                                        {team.name}
                                    </div>
                                    <div className='teams-page-content-my-teams-table-team-description'>
                                        <div className='teams-page-content-my-teams-table-team-description-text'>
                                            {team.description || 'No Description'}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>}
                  </div>                   
                )
            case 'Find a Team':
                return (
                    <div>
                    {!teams ?
                    <Spinner />
                    :
                    <div style={{ padding: 15, borderRadius: 10, backgroundColor: 'rgba(194, 194, 194, 0.4)', width: '93%', gap: 5 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: '0.5rem'}}>
                            <img src={clockIcon} style={{ width: 20, height: 20, filter: 'invert(100%)' }}/>
                            <div style={{ fontSize: 18, color: 'black', fontWeight: 'bold' }}>Coming soon</div>
                        </div>
                        <div style={{  fontSize: 13, color: 'black' }}>Exciting updates are on the way—stay tuned for more features coming soon!</div>
                    </div>
                    }
                  </div>
                )
        }
    }

    return (
        <div className='teams-page'>
            <div className='teams-page-title'>
                {/* <img src={teamsIcon} className='teams-page-title-icon'/> */}
                <div className='teams-page-title-text'>Teams</div>
            </div>
            <div className='teams-page-description'>Users can join teams where areas and/or alerts are shared across the team members.</div>
            {subStage === 'teams' ?
            <div className='teams-page-content'>
                <div className='teams-page-content-tabs'>
                    {['My Teams', 'Find a Team'].map((a, index) => (
                        <div
                            key={index}
                            className='teams-page-content-tabs-tab'
                            style={{
                                borderBottom: a === mainStage ? '2px solid #0080ff' : ''
                            }}
                            onClick={() => setMainStage(a)}
                        >
                           {a}
                        </div>
                    ))}
                </div>
                {mainStageSwitch(mainStage)}
            </div>
            :
            <div className='teams-page-content'>
                {team &&
                    <Team 
                        team={team}
                        setTeam={setTeam}
                        setSubStage={setSubStage}
                        getTeams={getTeams}
                    />
                }
            </div>
            }
        </div>
    );
}